import { cn } from '@components/lib/utils';

/* The column the panel occupies in the page's flex row. It alone decides how
 * much width the page gives up: the collapsed rail while floating, the whole
 * panel while pinned. */
export const railClass = (isPushing: boolean): string =>
  cn(
    'sticky top-0 z-20 h-screen min-h-screen shrink-0 transition-[width] duration-300 ease-in-out max-[1279px]:hidden',
    isPushing ? 'w-[450px]' : 'w-[72px]',
  );

/* The panel itself, anchored to the rail's right edge and growing leftwards —
 * which is what lets a floating panel overlay the page instead of reflowing
 * it. Only a floating panel casts a shadow; a pinned one has its own column
 * and nothing to lift off of. (Same shadow as the right-side `Drawer`.) */
export const panelClass = (
  isCollapsed: boolean,
  pinned: boolean,
  forceCollapse: boolean,
): string =>
  cn(
    'absolute top-0 right-0 flex h-screen flex-col overflow-hidden border-l border-border bg-card p-4 transition-[width] duration-300 ease-in-out',
    isCollapsed ? 'w-[72px]' : 'w-[450px]',
    !isCollapsed && !pinned && 'shadow-[-4px_0_24px_rgba(0,0,0,0.1)]',
    isCollapsed && !forceCollapse && 'cursor-pointer',
  );
